export function readResolvedStepState(step) {
  if (!step || typeof step !== "object") {
    return {
      completed: false,
      unlocked: false,
      eligible: false,
      available: false,
      attemptEligible: false,
      repeatable: false,
      denialReason: "PROGRAM_STEP_STATE_UNAVAILABLE"
    };
  }

  return {
    completed: step.completed === true || step.isCompleted === true,
    unlocked: step.unlocked === true || step.isUnlocked === true,
    eligible: step.eligible === true,
    available: step.available === true,
    attemptEligible: step.attemptEligible === true,
    repeatable:
      step.resolvedExecutionPolicy?.attempt?.mode === "repeatable",
    denialReason: step.denialReason || null
  };
}

export function readResolvedStepDenialPresentation(step) {
  const state = readResolvedStepState(step);
  if (state.eligible) return null;

  const calendarDayEntry = step?.resolvedExecutionPolicy?.temporalDelivery
    ?.calendarDayEntry;
  if (
    state.denialReason === "PROGRAM_STEP_TEMPORAL_ENTRY_BLOCKED" &&
    calendarDayEntry?.state === "waiting_for_next_calendar_day"
  ) {
    return {
      title: "Available tomorrow",
      reasonCode: state.denialReason,
    };
  }

  return {
    title: "Step unavailable",
    reasonCode: state.denialReason,
  };
}
